/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function TextUnderline(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M224,216a7.99977,7.99977,0,0,1-8,8H40a8,8,0,0,1,0-16H216A7.99977,7.99977,0,0,1,224,216Zm-96-24a72.0814,72.0814,0,0,0,72-72V56a8,8,0,0,0-16,0v64a56,56,0,0,1-112,0V56a8,8,0,0,0-16,0v64A72.0814,72.0814,0,0,0,128,192Z" />
    </Svg>
  );
}

export default TextUnderline;
